'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var fileSelector = require('../node_modules/file-selector/dist/es5/file-selector.js');
var styles = require('@material-ui/styles');
var Typography = require('@material-ui/core/Typography');
var ButtonBase = require('@material-ui/core/ButtonBase');
var WarningIcon = require('@material-ui/icons/Warning');
var DescriptionIcon = require('@material-ui/icons/Description');
var PhotoIcon = require('@material-ui/icons/Photo');
var files = require('../utils/files.js');
var CircleLoader = require('../CircleLoader/CircleLoader.js');
var Spacer = require('../Spacer/Spacer.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Typography__default = /*#__PURE__*/_interopDefaultLegacy(Typography);
var ButtonBase__default = /*#__PURE__*/_interopDefaultLegacy(ButtonBase);
var WarningIcon__default = /*#__PURE__*/_interopDefaultLegacy(WarningIcon);
var DescriptionIcon__default = /*#__PURE__*/_interopDefaultLegacy(DescriptionIcon);
var PhotoIcon__default = /*#__PURE__*/_interopDefaultLegacy(PhotoIcon);

var IMAGE_TYPES = ['png', 'jpg', 'jpeg', 'gif', 'svg'];
var useStyles = styles.makeStyles(theme => ({
  fileInput: {
    position: 'fixed',
    top: -9999,
    left: -9999,
    height: 0,
    width: 0
  },
  dropzone: {
    height: props => props.isResponsive ? '100%' : 250,
    width: props => props.isResponsive ? '100%' : 250,
    padding: 16,
    border: props => props.isDragging ? "1px solid ".concat(theme.palette.primary.main) : "1px solid ".concat(theme.palette.grey[300]),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: props => props.isDragging ? theme.palette.primary[50] : theme.palette.grey[100],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      border: "2px solid ".concat(theme.palette.secondary.main),
      backgroundColor: "2px solid ".concat(theme.palette.grey[50])
    }
  },
  dropzoneIcon: {
    fontSize: theme.typography.h3.fontSize,
    color: props => props.hasError ? theme.palette.error.main : theme.palette.grey[300]
  }
}));

function validateFile(_ref) {
  var {
    file,
    allowedExtensions,
    maxFileSize
  } = _ref;

  if (!file) {
    throw new Error('No file value');
  }

  var extension = files.getFileExtension(file.name);

  if (allowedExtensions.length > 0 && !allowedExtensions.includes(extension)) {
    throw new Error("Only the following file types are accepted: ".concat(allowedExtensions.join(', '), "."));
  }

  if (maxFileSize && file.size > files.sizeToBytes(maxFileSize)) {
    throw new Error("Maximum file size is ".concat(maxFileSize));
  }
}

var Dropzone = _ref2 => {
  var {
    onChange: _onChange,
    allowedExtensions: allowedExtensionsFromProps = [],
    maxFileSize = '5 M',
    isImage = false,
    isResponsive = false,
    maxFileCount = 1,
    label = '+ Add Files',
    isLoading = false
  } = _ref2;
  var allowedExtensions = !isImage ? allowedExtensionsFromProps : allowedExtensionsFromProps.length ? allowedExtensionsFromProps.filter(ext => IMAGE_TYPES.includes(ext)) : IMAGE_TYPES;
  var inputRef = React__default['default'].useRef();
  var containerRef = React__default['default'].useRef();
  var [errors, setErrors] = React__default['default'].useState(null);
  var [isDragging, setIsDragging] = React__default['default'].useState(null);
  var classes = useStyles({
    isResponsive,
    isDragging,
    hasError: errors === null || errors === void 0 ? void 0 : errors.length
  }); // Stop the global event from dropping the file.

  var onWindowDrop = event => {
    if (containerRef.current && containerRef.current.contains(event.target)) {
      return;
    }

    event.preventDefault();
  };

  var onDragOver = event => {
    event.stopPropagation();
    event.preventDefault();
    var isValidDrag = containerRef.current && containerRef.current.contains(event.target) && event.dataTransfer.items && event.dataTransfer.items.length > 0;

    if (isValidDrag) {
      setIsDragging(true); // processFile({ setError, allowedExtensions, maxFileSize, onChange, event })
    } else {
      setIsDragging(false);
    }
  };

  var onDragEnd = event => {
    event.stopPropagation();
    event.preventDefault();
    setIsDragging(false);
  };

  var processFiles = fileList => {
    var errors = [];
    var validFiles = [];

    for (var index = 0; index < fileList.length; index += 1) {
      var file = fileList[index];

      try {
        validateFile({
          file,
          allowedExtensions,
          maxFileSize
        });
        validFiles.push(file);
      } catch (error) {
        errors.push([file.name, error]);
      }
    }

    setErrors(errors);
    return _onChange({
      errors,
      files: validFiles
    });
  };

  React__default['default'].useEffect(() => {
    var onDrop = /*#__PURE__*/function () {
      var _ref3 = _rollupPluginBabelHelpers.asyncToGenerator(function* (event) {
        event.stopPropagation();
        event.preventDefault();
        var files = yield fileSelector.fromEvent(event);

        if (files.length > 0) {
          processFiles(files);
        }
      });

      return function onDrop(_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    window.addEventListener('dragover', onDragOver, false);
    window.addEventListener('dragend', onDragEnd, false);
    window.addEventListener('drop', onWindowDrop, false);

    if (containerRef.current) {
      containerRef.current.addEventListener('drop', onDrop, false);
    }

    return () => {
      window.removeEventListener('dragover', onDragOver);
      window.removeEventListener('dragend', onDragEnd);
      window.removeEventListener('drop', onDrop);

      if (containerRef.current) {
        containerRef.current.removeEventListener('drop', onDrop);
      }
    };
  }, [_onChange]);

  var focusInput = event => {
    event.stopPropagation();

    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  var IconComponent = errors !== null && errors !== void 0 && errors.length ? WarningIcon__default['default'] : isImage ? PhotoIcon__default['default'] : DescriptionIcon__default['default'];
  return /*#__PURE__*/React__default['default'].createElement(ButtonBase__default['default'], {
    ref: containerRef,
    className: classes.dropzone,
    onClick: focusInput
  }, isLoading ? /*#__PURE__*/React__default['default'].createElement(CircleLoader.CircleLoader, {
    size: 48
  }) : /*#__PURE__*/React__default['default'].createElement(IconComponent, {
    className: classes.dropzoneIcon
  }), /*#__PURE__*/React__default['default'].createElement(Spacer.Spacer, {
    axis: "vertical",
    size: 16
  }), errors !== null && errors !== void 0 && errors.length ? errors.map((error, index) => {
    var _error$;

    return /*#__PURE__*/React__default['default'].createElement(Typography__default['default'], {
      key: index,
      color: "error",
      align: "center"
    }, "Error with ".concat(error[0], ": ").concat(((_error$ = error[1]) === null || _error$ === void 0 ? void 0 : _error$.message) || 'Error'));
  }) : /*#__PURE__*/React__default['default'].createElement(Typography__default['default'], {
    color: "textSecondary",
    align: "center"
  }, isLoading ? 'Uploading files...' : label), /*#__PURE__*/React__default['default'].createElement("input", {
    disabled: isLoading,
    className: classes.fileInput,
    type: "file",
    ref: inputRef,
    multiple: maxFileCount > 1,
    onChange: event => {
      if (!event.target.files.length) {
        return _onChange(null);
      }

      return processFiles(event.target.files);
    }
  }));
};
Dropzone.propTypes = {
  onChange: index.func.isRequired,
  allowedExtensions: index.arrayOf(index.string),
  maxFileSize: index.string,
  isImage: index.bool,
  isLoading: index.bool,

  /** If `true`, the container element will stretch to the wrapper's height and width. */
  isResponsive: index.bool,
  maxFileCount: index.number,
  label: index.string
};

exports.Dropzone = Dropzone;
exports.default = Dropzone;
